module.exports = __webpack_public_path__ + "img/image2.adf146d2.svg";